import { useCallback, useEffect } from 'react';

import { selectCurrentUser } from 'store/user/selectors';

import { USER_SOURCE } from 'constants/urlParams';

import { Main, Provider } from 'services/Analytics/core';
import { ERROR_LEVELS, SENTRY_ANALYTIC } from 'services/Sentry/constants';
import sentry from 'services/Sentry/SentryInstance';

import { useSelector } from 'hooks';

import { setIdToTheProvider } from './helpers';

export function useAnalytic() {
    const { country, user_id, gender, id } = useSelector(selectCurrentUser);

    const clientHandlerFn = (e: Error) => sentry.logError(e, SENTRY_ANALYTIC, ERROR_LEVELS.ERROR);
    const getUtmSource = () => localStorage.getItem('utmSource') || undefined;
    const getUserSource = () => sessionStorage.getItem(USER_SOURCE) || undefined;

    const setAnalyticData = useCallback(() => {
        Provider.provideData({
            country: async () => country,
            utmSource: getUtmSource(),
            userSource: getUserSource(),
            // @ts-ignore
            clientHandlerFn,
        });

        setIdToTheProvider(id);

        (id || user_id) && Main.setUserProperties({ user_id: id || user_id });
    }, [country, id, user_id]);

    useEffect(() => setAnalyticData(), [setAnalyticData]);

    useEffect(() => {
        gender && localStorage.setItem('gender', gender);
    }, [gender]);
}
